import { ConfirmationSections } from 'src/module/FormKit/model';
import { RefillFormData } from '../model';

import { REFILL_STEPS } from './productSteps';
import { mask } from 'react-native-mask-text';
import { PHONE_MASK, INTL_PHONE_MASK } from 'src/constants';
import { capitalize } from 'lodash';

export const REFILL_CONFIRMATION: ConfirmationSections<REFILL_STEPS, RefillFormData> = {
  patientInfo: {
    title: 'section.patientInfo',
    dataKey: 'patientInfo',
    fields: [
      'name',
      'breed',
      {
        field: 'sex',
        component: ({ values }) => capitalize(values.patientInfo.sex)
      },
      'age'
    ],
    stateKey: REFILL_STEPS.PATIENT_INFO,
    fieldDisplay: 'row'
  },
  clientInfo: {
    title: 'section.clientInfo',
    dataKey: 'clientInfo',
    fields: [
      'fullName',
      'emailAddress',
      {
        field: 'phoneNumber',
        component: ({ values }) =>
          mask(values.clientInfo?.phoneNumber ?? '', [PHONE_MASK, INTL_PHONE_MASK])
      }
    ],
    stateKey: REFILL_STEPS.CLIENT_INFO,
    fieldDisplay: 'row'
  },
  additionalInfo: {
    title: 'section.productInfo',
    dataKey: 'additionalInfo',
    fields: [
      {
        field: 'productDescription',
        fieldDisplay: 'row'
      },
      {
        field: 'productQuantity',
        fieldDisplay: 'row'
      },
      'productComments'
    ],
    stateKey: REFILL_STEPS.ADDITIONAL_INFO,
    fieldDisplay: 'column',
    namespace: 'refill'
  },
  notificationSettings: {
    title: 'section.notificationSettings',
    dataKey: 'notificationSettings',
    fields: [
      {
        field: 'smsOptIn',
        component: ({ values: { notificationSettings } }) =>
          notificationSettings?.smsOptIn ? 'form.smsTrue' : 'form.smsFalse'
      },
      {
        field: 'preferredContactMethod',
        component: ({ values: { notificationSettings } }) =>
          `form.${notificationSettings?.preferredContactMethod ?? ''}`
      }
    ],
    stateKey: REFILL_STEPS.NOTIFICATION_SETTINGS,
    fieldDisplay: 'row'
  }
};
